import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import ROUTER from './dynamicRouter.js'


// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
//
//
Vue.use(VueRouter)

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'home',
//       component: () => import('@/pages/home/index'),
//     },
//   ]
// })
const routes = [
  {
    path: '/login',
    component: () => import('@/pages/login.vue'),
    name: '',
    hidden: true
  },
  {
    path: '/reset_password',
    component: () => import('@/pages/setting/resetPassword.vue'),
    name: 'reset_password',
    hidden: true
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/home/index'),
    hidden: true,
  }
]

const originalReplace = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalReplace.call(this , location).catch(err=>err)
}

const router = new VueRouter({
  routes
})
router.selfAddRoutes = function (params) {
  router.matcher = new VueRouter().matcher;
  router.addRoutes(params)
}
// 防止刷新的时候丢失路由
function getRoute() {
  // if (localStorage.getItem('dynamicRoutes')) {
    let routerlist = []
    // 这里是调用router.js里的方法拿到动态路由
    ROUTER.getRouterList(function (data) {
      routerlist = data
    })
    // 动态添加路由
    router.options.routes = routerlist
    router.selfAddRoutes([ ...routerlist ])
  // }
}
getRoute();
router.beforeEach((to, from, next) => {
  if (from.path === '/login') {
    // getRoute();
  }
  if (to.path === '/login') {
    sessionStorage.removeItem('user')
  }
  // store.commit('INIT_BASE', localStorage.getItem('base'));
  let user = JSON.parse(sessionStorage.getItem('user'))
  if (!user && to.path !== '/login' && !to.meta.no_login) { // 需登录查看
    next({
      path: '/login'
    })
    return;
  } else {
    const canNext = checkViewPermissions(user, from, to)
    if (canNext) {
      next()
    } else {
      console.log('无权限')
      next('/403')
      // next()
    }
  }
})
function checkViewPermissions(user, from, to) {
  // 用户是管理员的直接放行
  if (user && user.is_admin) return true;
  const path = `/${to.path.split('/')[1]}`
  // 访问目标path在noAuthRouter的直接放行
  const noAuthRouter = ['/login', '/reset_password', '/403', '/supplementDetail', '/user_supplement', '/product_edit', '/roles'];
  if (noAuthRouter.includes(path)) return true;

  const view_permissions = JSON.parse(window.sessionStorage.getItem('view_permissions'));
  return view_permissions.includes(path);
}
export default router




// WEBPACK FOOTER //
// ./src/router/index.js